import { learnerPaths } from '@app/routes/route-paths'
import type { LearnerRouteDefinition } from '@app/routes/learner-route-types'

export const learningRouteDefinitions = [
  {
    id: 'learning',
    legacyScreen: 0,
    navLabel: 'Learning',
    path: learnerPaths.learning,
    showInMainMenu: true,
    title: 'Learning',
  },
  {
    id: 'learning-ebooks',
    legacyScreen: 8,
    path: learnerPaths.learningEbooks,
    title: 'Online Ebook',
  },
  {
    id: 'learning-ebook-lessons',
    legacyScreen: 8,
    path: learnerPaths.learningEbookLessonsPattern,
    title: 'Online Ebook lessons',
  },
  {
    id: 'learning-ebook-reader',
    legacyScreen: 9,
    path: learnerPaths.learningEbookReaderPattern,
    title: 'Online Ebook reader',
  },
  {
    id: 'learning-audio',
    legacyScreen: 10,
    path: learnerPaths.learningAudio,
    title: 'Online Audio',
  },
  {
    id: 'learning-audio-book',
    legacyScreen: 10,
    path: learnerPaths.learningAudioBookPattern,
    title: 'Online Audio',
  },
  {
    id: 'learning-listening-quiz',
    legacyScreen: 7,
    path: learnerPaths.learningListeningQuiz,
    title: 'Online listening quiz',
  },
] satisfies readonly LearnerRouteDefinition[]
